import { render, staticRenderFns } from "./TasksDetails.vue?vue&type=template&id=1b019e71"
import script from "./TasksDetails.vue?vue&type=script&lang=js"
export * from "./TasksDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports